<div class="bg-base-200 min-h-dvh w-80">
    <div class="sticky top-0 z-10 bg-base-200 p-4 flex items-center gap-3 border-b border-base-300">
        @if (url) {
            <div class="avatar">
                <div class="w-12 rounded-full">
                    <img [src]="url" [alt]="name" />
                </div>
            </div>
        } @else {
            <div class="avatar avatar-placeholder">
                <div class="bg-neutral text-neutral-content w-12 rounded-full">
                    <span>{{ initials }}</span>
                </div>
            </div>
        }
        <div>
            <div class="font-bold">{{ name }}</div>
            <div class="text-xs text-base-content/70">{{ role }}</div>
        </div>
        <button type="button" class="ml-auto btn btn-ghost btn-square" (click)="closeSidenav()"
            [attr.aria-label]="'Layout.sidenav.close' | transloco">
            <ng-icon name="tablerX" size="24" aria-hidden="true" />
        </button>
    </div>

    <nav [attr.aria-label]="'Layout.sidenav.navigation' | transloco">
        <ul class="menu menu-lg w-full p-4 gap-1">
            @if (role === "Administrador" || role === "Delegado") {
            <li>
                <a routerLink="/habitational-units" routerLinkActive="menu-active" (click)="onNavigate()">
                    <ng-icon name="tablerBuildings" size="24" aria-hidden="true" />
                    {{ 'Layout.sidenav.habitational_units' | transloco }}
                </a>
            </li>
            <li>
                <a routerLink="/tickets" routerLinkActive="menu-active" (click)="onNavigate()">
                    <ng-icon name="tablerTicket" size="24" aria-hidden="true" />
                    {{ 'Layout.sidenav.tickets' | transloco }}
                </a>
            </li>
            <li>
                <a routerLink="/users" routerLinkActive="menu-active" (click)="onNavigate()">
                    <ng-icon name="tablerUsers" size="24" aria-hidden="true" />
                    {{ 'Layout.sidenav.users' | transloco }}
                </a>
            </li>
            <li>
                <a routerLink="/active-rents" routerLinkActive="menu-active" (click)="onNavigate()">
                    <ng-icon name="tablerHomeDollar" size="24" aria-hidden="true" />
                    {{ 'Layout.sidenav.rents' | transloco }}
                </a>
            </li>
            }

            @if (role === "Residente") {
            <li>
                <a routerLink="/habitational-unit-tenant" routerLinkActive="menu-active" (click)="onNavigate()">
                    <ng-icon name="tablerBuilding" size="24" aria-hidden="true" />
                    {{ 'Layout.sidenav.habitational_units' | transloco }}
                </a>
            </li>
            <li>
                <a routerLink="/tickets" routerLinkActive="menu-active" (click)="onNavigate()">
                    <ng-icon name="tablerTicket" size="24" aria-hidden="true" />
                    {{ 'Layout.sidenav.tickets' | transloco }}
                </a>
            </li>
            }
        </ul>
    </nav>
</div>
